import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PATH, API_DEV_SLA, APP_NOTIFICATION } from '../../globals';

export const baseApi = createApi({
    reducerPath: 'portrApi',
    baseQuery: fetchBaseQuery({ baseUrl: API_PATH }),
    keepUnusedDataFor: 0,
    endpoints: () => ({}),
});

export const baseApiSla = createApi({
    reducerPath: 'portrApiSla',
    baseQuery: fetchBaseQuery({ baseUrl: API_DEV_SLA }),
    keepUnusedDataFor: 0,
    endpoints: () => ({}),
});

export const notificationBaseApi = createApi({
    reducerPath: 'app_notification',
    baseQuery: fetchBaseQuery({ baseUrl: APP_NOTIFICATION }),
    keepUnusedDataFor: 0,
    endpoints: () => ({}),
});
